import { useAppContext } from "@/lib/contexts/appContext"
import { useArchiveContext } from "@/lib/contexts/archiveContext-2"
import Paging from "@/common/paging/paging"
import Loading from "@/components/common/loading/logo-with-text"
import classNames from "classnames"
import styles from "./grid.module.css"
import dynamic from "next/dynamic"

const cards = {
  "bra-miljoval": dynamic(() => import("@/common/cards/article/article")),
  "marking-areas": dynamic(() =>
    import("@/common/cards/marking-area/marking-area")
  ),
  projects: dynamic(() => import("@/common/cards/project/project")),
  products: dynamic(() => import("@/common/cards/product/product")),
  site: dynamic(() => import("@/common/cards/search/search"))
}

export default function Grid({ block, trackClick }) {
  const app = useAppContext()
  const store = useArchiveContext()
  const list = store.getList()
  const context = store.getContext()
  const currentPage = store.getPage()
  const loading = store.getLoading()
  const hasSearched = store.getHasSearched()

  if (loading) {
    return (
      <div className={classNames(styles.result, "is-empty")}>
        <Loading />
      </div>
    )
  }

  if (!loading && list.length === 0) {
    if (block.attrs.data?.isEmpty && !hasSearched) {
      return null
    }

    return (
      <div className={classNames(styles.result, "is-empty")}>
        <h2>{block.attrs?.emptyHeading ?? "Hittade ingenting"}</h2>
        <p>{block.attrs?.emptyText ?? "Prova att söka på något annat."}</p>
      </div>
    )
  }

  return (
    <div className={classNames(styles.result, "context-" + context)}>
      <div className="view-grid">
        <Items {...{ list, context, trackClick }} />
      </div>
      {!store.loading && (
        <div className="text-center">
          <Paging
            currentPage={currentPage}
            maxPage={store?.maxPage}
            elemRef={app?.searchFormRef}
            setPage={(page) => store.setPage(page)}
          />
        </div>
      )}
    </div>
  )
}

const Items = ({ list, context, trackClick }) => {
  return list.map((post) => {
    const Card = cards[context]

    if (!Card) {
      return null
    }

    const key = [context, post.id ?? post.url].join("-")
    return <Card key={key} post={post} trackClick={trackClick} />
  })
}
